/* WTF drawer cart (2026-10-04): saves the gift message to the cart attribute "Gift Message" as the shopper types.
   Why: the drawer re-renders on every add and every quantity change, which would wipe unsaved text.
   The key must stay exactly "Gift Message" (the Shopify Flow fulfillment hold reads it).
   The checkout button also posts the textarea (form="CartDrawer-Form"), so this is a second, earlier save.
   A re-render can arrive before a save lands, so the newest typed text is kept in `shared` and put back into the new textarea (3 s window). */
(function () {
  'use strict';
  if (customElements.get('wtf-cart-gift')) return;
  var KEY = 'Gift Message';
  var WAIT = 400;
  var KEEP_MS = 3000;
  var shared = { value: null, until: 0 };
  var live = null;   /* R545: the connected element, so the Check out tap can ask whether the note is saved */
  var saving = 0;    /* R545: saves in flight */

  class WtfCartGift extends HTMLElement {
    constructor() {
      super();
      this._t = null;
      this._last = null;
      this.addEventListener('input', this._queue.bind(this));
      this.addEventListener('change', this._save.bind(this));
    }

    connectedCallback() {
      live = this;
      var ta = this.querySelector('textarea');
      if (!ta) return;
      if (this._last === null) this._last = ta.value;
      if (shared.value !== null && Date.now() < shared.until && ta.value !== shared.value) {
        ta.value = shared.value;
        this._last = shared.value;
        var box = this.closest('details');
        if (box && shared.value !== '') box.open = true;
      }
    }

    disconnectedCallback() {
      /* The drawer re-render removes this element. Save any pending text first. */
      if (this._t) this._save();
      if (live === this) live = null;
    }

    _queue() {
      var ta = this.querySelector('textarea');
      if (ta) { shared.value = ta.value; shared.until = Infinity; }
      if (this._t) window.clearTimeout(this._t);
      this._t = window.setTimeout(this._save.bind(this), WAIT);
    }

    _save() {
      if (this._t) { window.clearTimeout(this._t); this._t = null; }
      var ta = this.querySelector('textarea');
      if (!ta) return;
      var value = ta.value;
      if (value === this._last) { if (shared.value === value) shared.until = Date.now() + KEEP_MS; return; }
      var previous = this._last;
      this._last = value;
      shared.value = value; shared.until = Infinity;
      var attributes = {};
      attributes[KEY] = value;
      var config = typeof fetchConfig === 'function'
        ? fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
      var self = this;
      saving++;
      fetch(url, Object.assign({}, config, { body: JSON.stringify({ attributes: attributes }) }))
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function () { if (shared.value === value) shared.until = Date.now() + KEEP_MS; })
        .catch(function () { self._last = previous; if (shared.value === value) shared.until = Date.now() + KEEP_MS; })
        .then(function () { saving = Math.max(0, saving - 1); });
    }
  }

  customElements.define('wtf-cart-gift', WtfCartGift);

  /* R545 (2026-10-09): true only when the note on screen is already the note on the cart: no timer waiting, no save in flight,
     the last save did not fail. Read by wtf-cart-checkout.js. Any doubt answers false and Check out takes the stock path. */
  window.WtfCartGift = {
    isSaved: function () {
      if (saving > 0 || !live) return false;
      var ta = live.querySelector('textarea');
      if (!ta) return true;
      if (live._t) return false;
      return ta.value === live._last;
    }
  };
})();
